import React from 'react';
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import MapForm from "./MapForm";

class MapFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>];
    return (
        <Page title="Dados do Mapa" breadcrumbs={breadcrumbs}>
          <MapForm match={match} history={history}/>
        </Page>
    );
  }
}

export default MapFormPage;



// WEBPACK FOOTER //
// ./src/map/MapFormPage.js